// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_16kuEtjnoTj0tabwDDgVWs","choicesDiv":"_3T7VXns9uFi3BJOJl_3xXP","buttonDiv":"_272MJLe8cS6oETfkmauPqv","buttonBack":"_2r7Hrn710dLSrrvqW_m9Q2","buttonNext":"_2LRDM6cKN6xp4sLy2Fm5Yp","textarea":"_29Z42cP1KcIgYGlpbYx7Ih"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/Panel/styles.scss
 ** module id = 430
 ** module chunks = 0
 **/